import React from "react";
import {useTranslation} from "react-i18next";

import MDInput from "materialDashboard/components/MDInput";
import {getIn} from "formik";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";


const IncidentMultiSelect = ({
                           name,
                           registry,
                           formik,
                           labelFn = r => `${r.code} - ${r.description}`,
                           onChange,
                           attrValue = 'code',
                           ...props
                       }) => {
    const {t} = useTranslation(['incidents']);

    const value = getIn(formik.values, name) ?? [];
    const error = getIn(formik.errors, name);
    const touched = getIn(formik.touched, name);

    const handleSelect = (event) => {
        const selected = event.target.value;
        formik.setFieldValue(name, registry.filter(r => selected.includes(r[attrValue])));
    }

    return <MDInput select
                    name={name}
                    label={t(`incidentForm.${name}`)}
                    value={value.map(v => v[attrValue])}
                    onChange={onChange === undefined ? handleSelect : onChange}
                    error={touched && Boolean(error)}
                    helperText={touched && error}
                    variant="standard"
                    fullWidth
                    SelectProps={{
                        multiple: true,
                        renderValue: (selected) => selected.map(s => registry.find(r => r[attrValue]===s)?.description).join(', '),
                        MenuProps:{style: { maxHeight: 400}}
                    }}
                    {...props}>
        <option label=""></option>
        {
            registry.map((op) => (
                <MenuItem key={op[attrValue]} value={op[attrValue]}>
                    <Checkbox checked={Boolean(value.some(i => i[attrValue] === op[attrValue]))} color='info'/>
                    <ListItemText primary={op.description} primaryTypographyProps={{variant: 'body2'}}/>
                </MenuItem>
            ))
        }
    </MDInput>
}

export default IncidentMultiSelect;